/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '@dm/core';

import { UnixPermissionConfigCardComponent } from './unix-permisssion-config-card.component';


@NgModule({
    declarations: [UnixPermissionConfigCardComponent],
    exports: [UnixPermissionConfigCardComponent],
    imports: [
        CommonModule,
        CoreModule,
        ReactiveFormsModule,
        FormsModule,
    ],
})
export class UnixPermissionConfigCardModule {}
